"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Stopwatch {
    constructor() {
        this.startTime = performance.now();
    }
    static startNew() {
        return new Stopwatch();
    }
    getElapsedMs() {
        return performance.now() - this.startTime;
    }
}
exports.default = Stopwatch;
